import { LoginResponse } from '@api/auth';
import { AuthInitialState } from '../data/slices/authSlice';
import {
  LOCAL_STORAGE_LAST_USER_KEY,
  LOCAL_STORAGE_USER_SLICE_KEY,
} from '../shared/constants';

export const getLocalStorageAuthState = (): Pick<
  AuthInitialState,
  'user' | 'accessToken' | 'refreshToken'
> => {
  try {
    return JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_SLICE_KEY) ?? '');
  } catch {
    return {
      refreshToken: null,
      accessToken: null,
      user: null,
    };
  }
};

export const setLoaclStorageAuthState = (authState: LoginResponse) => {
  localStorage.setItem(LOCAL_STORAGE_USER_SLICE_KEY, JSON.stringify(authState));
};

export const hasAccessTokenExpired = (): boolean => {
  const { accessToken } = getLocalStorageAuthState();

  if (!accessToken) return true;

  const currentDateTime = new Date().getTime();
  const expiresAtTime = accessToken.expiresAt
    ? new Date(accessToken.expiresAt).getTime()
    : 0;

  return expiresAtTime < currentDateTime;
};

interface ActiveUser {
  userId: string;
  data: Date;
}

export const setLastActiveUser = (userId: string) => {
  const lastUser: ActiveUser = {
    userId,
    data: new Date(),
  };

  localStorage.setItem(LOCAL_STORAGE_LAST_USER_KEY, JSON.stringify(lastUser));
};

export const getLastActiveUser = (): ActiveUser | null => {
  const lastUser = localStorage.getItem(LOCAL_STORAGE_LAST_USER_KEY);

  if (!lastUser) return null;

  return JSON.parse(lastUser);
};
